import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";

import { ReactComponent as PhoneIcon } from "../../../assets/icons/phone.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(-0.25),
  },
  top: {
    display: "inline-flex",
  },
  icon: {
    marginRight: theme.spacing(0.75),
    paddingTop: theme.spacing(0.5),
  },
  phoneNumber: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: "600",
    lineHeight: 1,
    padding: 0,
    "& a": {
      color: "inherit",
    },
  },
  caption: {
    fontSize: theme.typography.pxToRem(15),
    padding: 0
  }
}));

const PhoneDesktop = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <div className={classes.icon}>
          <PhoneIcon width="18" height="18" />
        </div>
        <Typography className={classes.phoneNumber}>
          <Link href="tel:030555786496">030-555786496</Link>
        </Typography>
      </div>
      <Typography className={classes.caption}>Kostenlose Erstberatung</Typography>
    </div>
  );
};

export default PhoneDesktop;
